var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flats-page"},[_c('HomeMap'),_c('section',{staticClass:"flats",attrs:{"id":"tabulka"}},[_c('FlatsTable',{attrs:{"show-vr":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }